import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class UrgentCleaningService extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Urgent Cleaning Service | Same Day Cleaning Experts"
          description="Urgent cleaning service available. Same day and emergency cleaning for homes and offices."
          keywords="urgent cleaning service, same day house cleaning, emergency cleaning services, immediate cleaning gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Urgent & Same Day Cleaning Services
                </h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Urgent & Same Day Cleaning Services
                          </h4>
                          <p>
                            Unexpected situations require immediate cleaning
                            solutions. Our urgent cleaning service provides fast
                            response cleaning for homes and businesses. Whether
                            it's an accidental spill, a last-minute inspection,
                            or event clean-up, we are here to help.
                          </p>
                          <div className="dlab-info m-t30">
                            <h4 className="dlab-title m-t0">
                              Situations Requiring Urgent Cleaning
                            </h4>
                            <ul className="list-check primary">
                              <li>Accidental spills and stains</li>
                              <li>Last minute rental inspections</li>
                              <li>Clean-up after a party or event</li>
                              <li>Post-renovation debris removal</li>
                            </ul>
                          </div>
                          <p>
                            Our team is equipped with professional tools to
                            handle emergencies quickly and effectively.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default UrgentCleaningService;
